import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createOteFpa = ( {data} : {data: IPostNewOteFpa | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/OteFpa/InsertOteFpa`, data);
};

type QueryFnType = typeof createOteFpa;

type UseCreateOteFpaOptions = {
  data: IPostNewOteFpa | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateOteFpa = ({ config }: UseCreateOteFpaOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Κατηγορίας ΦΠΑ.`, 500);
            console.error('Couldnt create new OteFpa', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOteFpas"])
            addNotification("Δημιουργήθηκε Νέα Κατηγορία ΦΠΑ.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createOteFpa,
    })
}